import React, {useEffect, useState} from 'react';
import Layout from "../../components/Layout";
import axios from "axios";
import {Table} from "react-bootstrap";
import {Button,Form, Row, Col, FloatingLabel, Container} from "react-bootstrap";
import Modal from "react-modal";
import { useForm } from 'react-hook-form';
import StudentsItem from "../../components/StudentsItem";




const Students = () => {
    const [students, setSudents] = useState([])
    const [modalIsOpen, setIsOpen] = useState(false)
    const { register, handleSubmit, reset, formState: { errors } } = useForm();

    const onSend = data => {
        axios.post("https://613af3f5110e000017a453df.mockapi.io/students", data)
            .then(({data: student}) => {
                setSudents([...students, student])
                setIsOpen(false)
                reset()
            })
    }

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    }

    function closeModal() {
        setIsOpen(false);
    }

    const deleteStudent = (id) => {
        axios.delete(`https://613af3f5110e000017a453df.mockapi.io/students/${id}`)
            .then(({data}) => setSudents(students.filter(item => item.id !== id)))

    }
    
    const editStudent = (id, data) => {
      setIsOpen(true)
        axios.put(`https://613af3f5110e000017a453df.mockapi.io/students/${id}`, data)
            .then(({data}) => setSudents(students.map(item => item.id === id ? {...item, ...data} : item)))
    }


    useEffect(() =>{
        axios("https://613af3f5110e000017a453df.mockapi.io/students")
            .then(({data}) => setSudents(data))

    },[])

    return (
        <Layout>
            <Container>
                <Table striped bordered hover size="sm">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Phone number</th>
                        <th>Contract</th>
                        <th>Payed</th>
                        <th>Laptop</th>
                        <th>Group</th>
                        <th>Comment</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        students.map((item, idx)=>
                            <StudentsItem key={item.id} item={item} idx={idx} editStudent={editStudent} deleteStudent={deleteStudent}
                                          onSend={onSend}  closeModal={closeModal}
                                          customStyles={customStyles}
                            />
                        )
                    }
                    </tbody>
                </Table>
                <Button className='edit-btn d-block mt-5 ' onClick={() => setIsOpen(true)}>Add student</Button>
                <Modal
                    isOpen={modalIsOpen}
                    onRequestClose={closeModal}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className='position-relative'>
                        <Form onSubmit={handleSubmit(onSend)}>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="formGridName">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control id='formGridName' {...register("name", { required: true })} type="text" />
                                    {errors.name && <span className='text-danger'>Add name</span>}
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridNumber">
                                    <Form.Label>Phone number</Form.Label>
                                    <Form.Control id='formGridNumber' {...register("phone", { required: true })} type="text"  />
                                    {errors.phone && <span className='text-danger'>Add phone</span>}
                                </Form.Group>
                            </Row>

                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="formGridContract">
                                    <Form.Label>Summ of contract</Form.Label>
                                    <Form.Control id='formGridContract' {...register("contract", { required: true })} type="number" />
                                    {errors.contract && <span className='text-danger'>Add contract</span>}
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridPayed">
                                    <Form.Label>Payed</Form.Label>
                                    <Form.Control id="formGridPayed" {...register("pay", { required: true })} type="number"/>
                                    {errors.pay && <span className='text-danger'>Add pay</span>}
                                </Form.Group>
                            </Row>

                            <Form.Group className="mb-3" controlId="formGridLaptop">
                                <Form.Label>Laptop</Form.Label>
                                <Form.Control id="formGridLaptop" {...register("laptop", { required: true })} type="text"/>
                                {errors.laptop && <span className='text-danger'>Add laptop</span>}
                            </Form.Group>

                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="formGridGroup">
                                    <Form.Label>Group</Form.Label>
                                    <Form.Select {...register("group", { required: true })} defaultValue="Choose...">
                                        <option selected={true} disabled={true}>Choose group</option>
                                        <option>Morning</option>
                                        <option>Evening</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridStatus">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select id='formGridStatus' {...register("status", { required: true })} defaultValue="Choose...">
                                        <option selected={true} disabled={true}>Choose status</option>
                                        <option>Active</option>
                                        <option>Not active</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridGender">
                                    <Form.Label>Gender</Form.Label>
                                    <Form.Select id="formGridGender" {...register("gender", { required: true })} defaultValue="Choose...">
                                        <option selected={true} disabled={true}>Choose gender</option>
                                        <option>Male</option>
                                        <option>Female</option>
                                    </Form.Select>
                                </Form.Group>
                            </Row>
                            <FloatingLabel controlId="floatingTextarea2" label="Comments">
                                <Form.Control
                                    id='floatingTextarea2'
                                    {...register("comment", { required: true })}
                                    as="textarea"
                                    style={{ height: '100px' }}
                                />
                                {errors.comment && <span className='text-danger'>Add comment</span>}
                            </FloatingLabel>
                            <Button className='student-modal-btn' variant="primary" type="submit">
                                Submit
                            </Button>
                        </Form>
                        <div onClick={closeModal} className='close-modal position-absolute'>❌</div>
                    </div>
                </Modal>
            </Container>
        </Layout>
    );
};

export default Students;